import Vue from 'vue'
import ElementUI from 'element-ui';
import axios from './axios'
import 'element-ui/lib/theme-chalk/index.css';
import dataV from '@jiaminghi/data-view'
import router from './router.js';
import { website } from '@/config.js'
import draggable from '@/page/components/draggable'
import { loadScript } from '@/utils/utils'
import App from './App.vue'
import './styles/common.scss'
import '@/utils/es6'
import hljs from 'highlight.js' //导入代码高亮文件
import 'highlight.js/styles/atom-one-dark.css'  //导入代码高亮样式
import crypto from '@/utils/crypto.js'
import store from './store';
import { getRegister } from './api/sysconfig'

// import '@/mock/'
//导入主题文件
import '@/theme/index.js'
Vue.config.productionTip = false
window.axios = axios;
window.$loadScript = loadScript;
window.cryptoUtil = crypto;
document.title = website.title
Vue.use(ElementUI);
Vue.use(window.AVUE);
Vue.component('avue-draggable', draggable)
Vue.prototype.$website = website;
const $loadingParams = {};
$loadingParams['element-loading-text'] = "加载中..."
$loadingParams['element-loading-background'] = "rgba(32,32,35, 0.8)"
Vue.prototype.$loadingParams = $loadingParams
Vue.use(dataV)
Vue.use(store)
Vue.directive('highlight', function (el) {
  let highlight = el.querySelectorAll('pre code');
  highlight.forEach((block) => {
    hljs.highlightBlock(block)
  })
});

const app = new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')

// 在 Vue 实例创建后立即请求注册信息
getRegister().then(res => {
  let data = res.data?.data?.registerInfo
  console.log("注册信息",data);
  app.$store.dispatch('setRegisterInfo', data)
})